import { render, staticRenderFns } from "./VideoStudentContent.vue?vue&type=template&id=816a6970&scoped=true"
import script from "./VideoStudentContent.vue?vue&type=script&lang=js"
export * from "./VideoStudentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a6970",
  null
  
)

export default component.exports